import React from 'react'
import { useWatch } from 'react-hook-form'

import { SelectField } from './SelectField'
import { useGetDetailPageFieldQuery } from '../../generated/graphql'
import { useFormContext } from 'react-hook-form'
import { createDialog } from '@edge/spark/feature-dialog'

export const DetailPageField = () => {
    const { data, loading } = useGetDetailPageFieldQuery({
        onError: (error) => {
            console.log('DetailPageFieldError', { error })
            createDialog({ message: error.message })
        },
    })

    const { setValue } = useFormContext()
    const value = useWatch({ name: 'format.searchDetailView' })
    const detailPages = data?.auction?.reportDetailPages
    const selectedConfig = detailPages?.find((item) => item?.name === value)
    const linkUrl = selectedConfig?.url
    const linkLabel = selectedConfig?.displayName

    React.useEffect(() => {
        setValue('format.cardActionLabel', linkLabel)
    }, [linkLabel, setValue])

    React.useEffect(() => {
        setValue('format.cardActionUrl', linkUrl)
    }, [linkUrl, setValue])

    const options =
        !detailPages && loading
            ? [['', 'Loading...']]
            : detailPages
                  ?.map((item) => {
                      const label = item?.displayName
                      const key = item?.name

                      if (label && key) {
                          return [key, label]
                      }

                      return []
                  })
                  .filter((x) => x?.length) || [['', 'Error']]

    return <SelectField label="Detail Page" name="format.searchDetailView" options={options} loading={loading} />
}
